<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

jQuery('.footer__content-bottom .footer-block__bottom .footer__copyright .copyright__content').append('<img class="securety-img" src="https://www.playfulmeow.com/cdn/shop/files/k4oxyn8.png">');

jQuery('.footer-block__details .image_logo').html('<a href="https://www.playfulmeow.com/"><img data-srcset="//www.playfulmeow.com/cdn/shop/files/logo-footer_200x.png?v=1722838101" class=" ls-is-cached lazyloaded" alt="Playful Meow" width="158" height="94" srcset="//www.playfulmeow.com/cdn/shop/files/logo-footer_200x.png?v=1722838101"></a>');

jQuery('.main-menu .header__inline-menu li.menu-lv-item:nth-child(1) a.menu-lv-1__action.header__menu-item').prepend('<label class="new-menutxt">New</label>');

jQuery('.new-menutxt').prepend('<i class="fa fa-caret-down" aria-hidden="true"></i>');

jQuery('.header__icon--cart').on('click', function() {
	setTimeout(function() {
		jQuery('.previewCartGroup #cart-sidebar-checkout').text('Proceed To Checkout');
	}, 1000);
});

jQuery('.section-block-template--16420769530026__163247026462da6862 .halo-block-content').append('<div class="viewalldiv"><a class="viw-all-bst" href="https://www.playfulmeow.com/collections/all">View All</a></div>');

jQuery('.section-block-template--16420769530026__16328142266b504c78 .halo-block-content').append('<div class="viewalldiv"><a class="viw-all-bst" href="https://www.playfulmeow.com/collections/all">View All</a></div>');

jQuery(document).ready(function() {
  setTimeout(function() {
    jQuery('#product-add-to-cart').html(jQuery('#product-add-to-cart').html().replace('Pre-order','Add to cart'));
  }, 500);
});

jQuery(document).ready(function() {
  setTimeout(function() {
    jQuery('#product-sticky-add-to-cart').html(jQuery('#product-sticky-add-to-cart').html().replace('Pre-order','Add to cart')); 
  }, 500);
});

jQuery('.contact-2 .contact-form .button.button--primary').val('Submit');